import { SET_CAROUSEL_POSITION } from './constants'

export function setCarouselPosition(id, position) {
    return {
        type: SET_CAROUSEL_POSITION,
        data: {
            id,
            position,
        },
    }
}
